export default __webpack_public_path__ + "static/media/drawing-woman6-focusfill.c185eb72.svg";